import { useState, useEffect } from 'react';
import {
  useTheme,
} from '@mui/material';
import { UserClaims } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import {  AppBar, Icons } from '@forgeglobal/forge-component-library';

const Header = (props: any) => {
  const theme = useTheme();
  const { authState, oktaAuth } = useOktaAuth();
  const [userClaims, setUserClaims] = useState<UserClaims>();

  useEffect(() => {
    if (authState && authState.isAuthenticated) {
      oktaAuth.getUser().then((userClaimsResult) => {
        setUserClaims(userClaimsResult);
      });
    }
  }, [authState, oktaAuth]);

  const headerActions = [
    {
      icon: <Icons.User />,
      buttons: [
        {
          icon: <Icons.User />,
          label: userClaims?.email || '',
          onClick: function noRefCheck() {},
        },
        {
          icon: <Icons.Logout />,
          label: "Logout",
          onClick: () => {
            oktaAuth.tokenManager.clear();
            oktaAuth.signOut();
          },
        },
      ],
    },
  ];


  return (
    <AppBar 
      headerActions={authState && authState.isAuthenticated ? headerActions : undefined }
      sx = {{ 
        marginLeft : theme.spacing(-2), 
        marginTop: theme.spacing(-0.5)
      }}
     />
  );
};

export default Header;
